export const WAEC_AGRIC_SCIENCE = [];
